import { buildCarPath } from "./api";

/** Public links consume resolved identities. A browser language preference is
 * not source evidence that another public car URL was published. */
export function carNavigationPath(
  car: Parameters<typeof buildCarPath>[0],
  _language?: string | null,
): string {
  return buildCarPath(car);
}
